import { useMemo } from 'react';
import useQueryParameters from '@shared/hooks/useQueryParameters';

export interface Features {
  animationControl: boolean;
  manualAudio: boolean;
  pushAudio: boolean;
}

export default function useFeatures(): Features {
  const queryParameters = useQueryParameters();
  return useMemo(() => {
    const audioOptions = queryParameters.getAll('audio');

    return {
      animationControl: queryParameters.get('animationControl') !== 'false',
      manualAudio: audioOptions.includes('manual'),
      pushAudio: audioOptions.includes('push'),
    };
  }, [queryParameters]);
}
